"use client";

import React from "react";
import Image from "next/image";
import { useFullPageContext } from "@/context/FullPageContext";
import { motion } from "framer-motion";

export default function RightSidebar() {
  const { activeIndex, scrollToSection, sections, isFullPage } =
    useFullPageContext();

  const totalSections = sections.length;

  if (!isFullPage || totalSections === 0) return null;

  const handleScrollDown = () => {
    const nextIndex = (activeIndex + 1) % totalSections;
    scrollToSection(nextIndex);
  };

  const sectionNum = String(activeIndex + 1).padStart(2, "0");
  const totalNum = String(totalSections).padStart(2, "0");

  return (
    <aside className="fixed right-6 md:right-8 top-24 md:top-28 bottom-8 z-50 flex flex-col justify-between items-end pointer-events-none select-none">
      {/* TOP: SECTION COUNTER (01 / 08) - CLEAN TEXT WITHOUT BACKGROUND */}
      <div className="pointer-events-auto flex items-center gap-1 text-xs">
        <span className="font-bold text-[#C9AB81] tracking-widest font-lora text-sm">
          {sectionNum}
        </span>
        <span className="text-white/40 font-light mx-0.5">/</span>
        <span className="text-white/70 font-light tracking-widest font-lora text-xs">
          {totalNum}
        </span>
      </div>

      {/* BOTTOM: ROTATED TEXT "CUỘN ĐỂ KHÁM PHÁ" & SUBTLE ANIMATED DOWN ARROW */}
      <div
        onClick={handleScrollDown}
        className="pointer-events-auto flex flex-col items-center gap-2.5 cursor-pointer group"
      >
        <span className="[writing-mode:vertical-lr] uppercase tracking-[0.25em] text-[10px] md:text-[11px] font-medium text-white/70 group-hover:text-[#C9AB81] transition-colors duration-300 whitespace-nowrap">
          CUỘN ĐỂ KHÁM PHÁ
        </span>

        {/* Subtle, refined floating motion arrow */}
        <motion.div
          animate={{ y: [0, 5, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
          className="flex items-center justify-center pt-1"
        >
          <Image
            src="/icons/downOutLine_Icon.svg"
            alt="scroll down"
            width={9}
            height={8}
            className="w-2.5 h-2.5 object-contain brightness-200 group-hover:brightness-100 transition-all duration-300"
          />
        </motion.div>
      </div>
    </aside>
  );
}
